<template>
  <v-container fluid>
    <a-tabs v-model="tabKey" size="small" @change="changeTab">
      <a-tab-pane tab="商丘开封" :key="2"></a-tab-pane>
      <a-tab-pane tab="南阳信阳周口" :key="1"></a-tab-pane>
      <a-tab-pane tab="漯平许驻马店" :key="6"></a-tab-pane>
      <a-tab-pane tab="洛焦济三" :key="5"></a-tab-pane>
      <a-tab-pane tab="安濮鹤新" :key="3"></a-tab-pane>
      <a-tab-pane tab="全部" :key="98"></a-tab-pane>
      <!-- <a-tab-pane tab="交接班日志" :key="99"></a-tab-pane> -->
    </a-tabs>
    <!-- 运营审批页面：点击"运营审批"Tab时展示 approval.vue 内容 -->
    <!-- <Log v-if="tabKey === 99" ref="logRef" /> -->
    <!-- 派车计划页面 -->
    <DispatchPlanV98 v-if="tabKey === 98" ref="dispatchplanRef98" />
    <DispatchPlanV2 v-else ref="dispatchplanRef2" />
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import Log from "./log.vue";
import DispatchPlanV2 from "../dispatchplanv2.vue";
import DispatchPlanV98 from "../dispatchplanv98.vue";
export default {
  name: "Dispatchplan2",
  data() {
    return {
      tabKey: 2,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
  },
  components: { DispatchPlanV2, DispatchPlanV98, Log },
  watch: {
  },
  mounted() {
  },
  activated() {

  },
  methods: {
    changeTab(v) {
      console.log('changeTab', v);
      this.$nextTick(() => {
        if (v === 98) {
          this.$refs.dispatchplanRef98.init(v);
        }
        else {
          this.$refs.dispatchplanRef2.init(v);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-tabs-bar {
  margin: 0 !important;
}
</style>